<template functional>
	<div :class="[data.class, data.staticClass]">
		<span class="tablet:hidden tabletWide:unset inline-block mb-8 tabletWide:mb-0 font-bold text-18 text-goPink">Can’t find the help you’re looking for?</span>
		<span class="hidden tablet:unset tabletWide:hidden inline-block mb-8 tabletWide:mb-0 font-bold text-18 text-goPink">Can’t find the help?</span>
		<br class="tablet:hidden" />
		<component :is="injections.components.callUsButton" class="tablet:ml-32 text-goPink hover:text-goPinkDark active:text-goPinkDarker" />
		<component :is="injections.components.emailUsButton" class="ml-24 mr-12 tablet:mr-0 text-goPink" />
	</div>
</template>

<script>
import callUsButton from '~/components/callUsButton.vue';
import emailUsButton from '~/components/emailUsButton.vue';

export default {
	inject: {
		components: {
			default: {
				callUsButton,
				emailUsButton,
			}
		}
	},
};
</script>
